// extracted by mini-css-extract-plugin
module.exports = {"sign-in__form":"sign-in-form_sign-in__form__SlHmg","sign-in__btn-text":"sign-in-form_sign-in__btn-text__fxb36","sign-in__btn":"sign-in-form_sign-in__btn__YRDWq"};